export type MessageDirection = "inbound" | "outbound";
export type MessageChannel = "sms" | "call" | "note" | "system";
export type MessageDeliveryStatus = "sent" | "delivered" | "failed" | "pending";
export type CallOutcome = "completed" | "no_answer" | "busy" | "failed" | "voicemail" | "left_voicemail" | "spoke_to_customer";

export interface Message {
  id: string;
  conversationId: string;
  direction: MessageDirection;
  channel: MessageChannel;
  body: string;
  sender: string;
  timestamp: string;
  deliveryStatus?: MessageDeliveryStatus;
  /** For calls */
  callDuration?: number;
  callOutcome?: CallOutcome;
  /** Optional tag */
  tag?: string;
}

export interface Conversation {
  id: string;
  /** Unified contact reference — matches lead primaryName or job customerName */
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  /** Links */
  linkedLeadId?: string;
  linkedQuoteId?: string;
  linkedJobId?: string;
  /** Ownership */
  assignedRep: string;
  /** Meta */
  createdAt: string;
  updatedAt: string;
  lastMessagePreview: string;
  unreadCount: number;
}

export const CALL_OUTCOME_LABELS: Record<CallOutcome, string> = {
  completed: "Completed",
  no_answer: "No Answer",
  busy: "Busy",
  failed: "Failed",
  voicemail: "Voicemail",
  left_voicemail: "Left Voicemail",
  spoke_to_customer: "Spoke to Customer",
};

export const QUICK_TEMPLATES = [
  { id: "t1", label: "Appointment Confirmation", body: "Hi {name}, this is {rep} from Koredor. Just confirming your appointment on {date}. Please reply YES to confirm or call us to reschedule. Thank you!" },
  { id: "t2", label: "Follow-Up", body: "Hi {name}, this is {rep} from Koredor. I wanted to follow up on your project. Do you have any questions? Feel free to call or text back anytime." },
  { id: "t3", label: "On Our Way", body: "Hi {name}, our crew is on their way to your property. Expected arrival in approximately 30 minutes." },
  { id: "t4", label: "Project Complete", body: "Hi {name}, great news — your project has been completed! Please let us know if you have any questions or concerns." },
];
